import { render, staticRenderFns } from "./custom-radio-button.vue?vue&type=template&id=60a56c98&scoped=true"
import script from "./custom-radio-button.vue?vue&type=script&lang=js"
export * from "./custom-radio-button.vue?vue&type=script&lang=js"
import style0 from "./custom-radio-button.vue?vue&type=style&index=0&id=60a56c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a56c98",
  null
  
)

export default component.exports